import React from 'react';
import { LabelText, ValueText } from '../../../../index.js';

export default function InfoField({
  labelText,
  labelStyle,
  text,
  leftTextImage,
  rightTextImage,
  labelClassName,
  className,
  valueClassName,
  cardValueClassName,
  textStyle
}) {
  return (
    <div className={`info-field ${className}`}>
      <LabelText style={labelStyle} text={labelText} className={labelClassName} />
      <ValueText
        text={text}
        // value={text}
        textStyle={textStyle}
        leftImage={leftTextImage}
        rightImage={rightTextImage}
        className={valueClassName}
        cardValueClassName={cardValueClassName}
      />
    </div>
  );
}
